import * as React from 'react';
import { useEffect } from 'react';

import omit from 'lodash/omit';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import Retracked from 'js/lib/retracked';
import type { EventData, WithTrackingData } from 'js/lib/retracked';

import _t from 'i18n!nls/clips';

type RedirectWithoutProgramSlugProps = {
  router: InjectedRouter;
  _eventData: EventData;
  _withTrackingData: WithTrackingData;
  courseSlug: string;
  programSlug?: string;
  itemId: string;
};

const RedirectWithoutProgramSlug = ({
  router,
  _eventData,
  _withTrackingData,
  courseSlug,
  programSlug,
  itemId,
}: RedirectWithoutProgramSlugProps) => {
  useEffect(() => {
    const newQuery = omit(router.location.query, 'program');

    Retracked.trackComponent(
      _eventData,
      { courseSlug, programSlug, itemId },
      'sfc_redirect_url_without_program_slug',
      'view',
      _withTrackingData
    );

    router.replace({
      pathname: router.location.pathname,
      query: newQuery,
    });
  }, [_eventData, _withTrackingData, courseSlug, itemId, programSlug, router]);

  return (
    <div>
      <p>{_t('Redirecting...')}</p>
    </div>
  );
};

export default RedirectWithoutProgramSlug;
